import { useContext } from 'react';
import { Box, Grid } from '@mui/material';
import { DashboardContext, IDetailsPage } from '@contexts/dashboardContext';
import { T_DASHBOARD_FILTER_TYPES } from '@utils';
import AdminDashboardCollectionType from './CollectionType';

const AdminDashboardCollectionTypes = () => {
  const {
    state: { detailsPage },
  } = useContext(DashboardContext);

  const {
    detailsPageData: { selectedCollections },
  } = detailsPage as IDetailsPage;

  return (
    <Box sx={{ mt: 1, mb: 5 }}>
      <Box>
        {selectedCollections.map((selectedCollection: T_DASHBOARD_FILTER_TYPES) => (
          <Grid container spacing={3} key={selectedCollection}>
            <Grid item xl={12} sm={12} xs={12}>
              <AdminDashboardCollectionType collectionType={selectedCollection} />
            </Grid>
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

export default AdminDashboardCollectionTypes;
